export const zeroPrefixedNumber = (n: number) => (n >= 10 ? n.toString() : `0${n}`);
